<label class="field-label">
  {{ label }}
  @if (isRequired) {
    <span class="text-red-600" aria-hidden="true">*</span>
  }
</label>
@if (options) {
<div class="space-y-2">
  @for (option of options; track option; let i = $index) {
  <label
    class="flex items-center gap-x-2 py-2"
    [class.opacity-50]="isDisabled(option[valueKey])"
    [class.pointer-events-none]="isDisabled(option[valueKey])"
  >
    <input
      type="radio"
      [formControl]="control"
      [value]="option[valueKey]"
      [checked]="control.value === option[valueKey]"
      (change)="onValueChange(option[valueKey])"
      class="form-radio h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy"
      [name]="groupName"
    />
    <!-- [disabled]="isDisabled(option[valueKey]) || disabled" -->
    <span class="text-sm text-dc-navy">{{ option[labelKey] }}</span>
  </label>
  }

  <div class="fields-error-container">
    <!-- Show custom error messages -->
    @if (control.touched && control.invalid) { @for (errorKey of errorKeys;
    track errorKey) { @if (control.hasError(errorKey)) {
    {{
      validationMessages[errorKey] ||
        (errorKey === "required"
          ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
          : "Invalid value")
    }}
    } } }
  </div>
</div>
}
